module.exports = __webpack_public_path__ + "img/error.9926267e.png";